import { Route, RouteObject } from 'react-router-dom'

/**
 * Renders an array of route objects into Route components
 */
export const renderRoutes = (routes: RouteObject[]) =>
  routes.map((route) => {
    const { path, element, children } = route
    return (
      <Route key={path} path={path} element={element}>
        {children && renderRoutes(children)}
      </Route>
    )
  })
